import { Divider } from '@cleartrip/bento/components/Divider'
import React, { useState, useEffect } from 'react'
import { DownChevronBlack } from '../../assets/svgs/hiFive/index'

const FaqAccordion = ({ title = '', msg = '', noBottomBorder, index, setCurrActive, currActive }) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => {
    setIsOpen(!isOpen)
    if (isOpen) {
      setCurrActive(-1)
    } else {
      setCurrActive(index)
    }
  }
  useEffect(() => {
    if (currActive === index) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  }, [currActive])

  return (
    <div
      className="faq-accordion  pb-16 pt-16 c-pointer"
      onClick={toggle}
      style={{ borderBottom: `${noBottomBorder ? 'none' : '1px solid rgba(255, 255, 255, 0.1)'}` }}
    >
      <div className="flex flex-column">
        <div className="flex flex-middle flex-between pt-4">
          <p className=" fs-3 lh-20  fw-400">{title}</p>
          <span className={`${isOpen ? 'chevronUp' : 'chevronDown'}`}>
            <DownChevronBlack onClick={toggle} />
          </span>
        </div>
        <Divider className="pb-4" />
      </div>
      {isOpen && <div className="faq-accordion-content fs-12 lh-18  pt-3 fw-400 pb-4">{msg}</div>}

    </div>
  )
}

export default FaqAccordion
